import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    contactCardContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    toolbarContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap"
    },
    loadingContainer: {
        justifyContent: "center",
        alignItems: "center",
        minHeight: 240
    },
    emptyContainer: {
        justifyContent: "center",
        alignItems: "center",
        minHeight: 200
    },
    cardDetailsContainer: {
        flexDirection: "column",
        flex: 1
    },
    listContainer: {
        flexDirection: "column"
    },
    toolbarActionsContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    cardContactContainer: {
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap"
    },
    cardActionsContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    contactInfoItemRow: {
        flexDirection: "row",
        alignItems: "center"
    },
    cardTitleContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    cardDateContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    paginationContainer: {
        alignItems: "center"
    },
    searchInputContainer: {
        maxWidth: 360,
        flex: 1
    },
    fullNameText: {
        fontWeight: "600"
    },
    subjectText: {
        fontWeight: "600"
    },
    container: {
        flex: 1
    }
});
export default stylesheet;
